import React from 'react';
import { HUBSPOT_FORM_SOURCE } from '/src/lib/constants';
import { PUBLIC_IMG_URL } from '/src/lib/endpoints';

import LandingPageComponent from './components/LandingPageComponent';

const InvestorsDirectoryLanding = (props) => {

    const contactFormConfig = {
        contactSalesPage: HUBSPOT_FORM_SOURCE.investor_dir_locked_section
    };

    const customFeaturesData = ({ totalInvestors }) => [
        {
            id: 'investor-landscape',
            title: 'Explore the Investor Landscape at a Glance',
            description: `From global venture capital firms to regional accelerators, our investor directory contains ${totalInvestors} investment firms. Track their investment history, deployed capital and focus areas, all in one place.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/investors-directory.webp`,
            altText: 'Investor Directory Feature',
            buttonText: 'Speak to our Team',
        },
        {
            id: 'right-investors',
            title: 'Zero In on the Right Investors',
            description: `Refine your search with advanced filters across investor type, region, industry focus, and stage preferences. Whether you're tracking investment trends or mapping the market, the answers are just a few clicks away.`,
            image: `${PUBLIC_IMG_URL}/directory-landing/filter-search.webp`,
            altText: 'Investor Search Feature',
            buttonText: 'Book a Demo',
        }
    ];

    const customPageMetadata = ({ totalInvestors }) => ({
        pageTitle: 'Investors Directory Landing Page',
        title: `Your Gateway to ${totalInvestors} Global Investors`,
        description: "Discover how leading venture capital firms and accelerators are fueling the next wave of innovation across Emerging Markets. Explore in-depth analytics on funding trends, investor activity, and capital distribution across Emerging Market ecosystems.",
        url: '/investors',
        componentName: 'InvestorsDirectoryLanding',
        landingPageType: 'Investors',
        amplitudeEvent: 'Clicked Contact Sales from Investors Directory Landing Page',
        heroButtonText: 'Learn More',
    });

    return (
        <LandingPageComponent
            contactFormConfig={contactFormConfig}
            customFeaturesData={customFeaturesData}
            customPageMetadata={customPageMetadata}
            className="investors-directory-landing-container"
            showVideoSection={false}
            location={props.locationSearch}
        />
    );
};

export default InvestorsDirectoryLanding;
